import React from "react";

// utils
import { twMerge } from "tailwind-merge";

// types
import { objectsToString } from "@/components/utils";
import clsx from "clsx";
import {
  children,
  className,
  propTypesChildren,
  propTypesClassName,
} from "../utils/types";
import { list } from "./listStyle";

export interface ListItemSuffixProps extends React.ComponentProps<"div"> {
  className?: className;
  children: children;
}

export const ListItemSuffix = React.forwardRef<
  HTMLDivElement,
  ListItemSuffixProps
>(({ className, children, ...rest }, ref) => {
  // 1. init
  const { styles } = list;

  // 2. set styles
  const listItemSuffixClasses = twMerge(
    clsx(objectsToString(styles?.base?.itemSuffix)),
    className
  );

  return (
    <div {...rest} ref={ref} className={listItemSuffixClasses}>
      {children}
    </div>
  );
});

ListItemSuffix.propTypes = {
  className: propTypesClassName,
  children: propTypesChildren,
};

ListItemSuffix.displayName = "ListItemSuffix";

// export default ListItemSuffix;
